module.exports = __webpack_public_path__ + "static/media/tusd.e038173b.svg";